import {
  Control,
  Controller,
  UseFormGetValues,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmpPosition } from '~/data/employee/types';
import { UnitPosition } from '~/data/unitPositions';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/components/FormComponent/components/Common/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  empData: EmpPosition;
  unitPositions: UnitPosition[];
  index: number;
};

export const UnitPositionComponent = ({
  control,
  getValues,
  empData,
  unitPositions,
  index,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  // @ts-ignore
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  const fInternalPositionUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );

  const filteredUnitPositions = unitPositions.filter(
    (up) =>
      up.fUnitPositionUnitFk === fInternalPositionUnitValue ||
      (!fInternalPositionUnitValue &&
        up.fUnitPositionUnitFk === empData.fInternalPositionUnit),
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.empPosition.fEmpUnitPositions`}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          disabled={fInternalPositionUnitValue === -1}
          sx={sxStyles.selectStyle}
          placeholder={' '}
          options={filteredUnitPositions}
          getOptionLabel={(c) =>
            `${c.fUnitPositionPosNumber}, ${c.fUnitPositionName}`
          }
          onChange={(e, value) => {
            onChange(value.map((up) => up.fUnitPositionId));
          }}
          value={
            filteredUnitPositions.filter((up) =>
              value.includes(up.fUnitPositionId),
            ) || []
          }
          multiple
          label={t('fEmpUnitPositions')}
        />
      )}
    />
  );
};
